import {
  FETCH_FACILITIES,
  RESET_SEARCH,
  FETCH_FACILITY,
  FETCH_GENERATOR,
  FETCH_TRANS1,
  FETCH_TRANS2,
  FETCH_TSDF,
  FETCH_ALTTSDF,
  UPDATE_SELECTION,
  UPDATE_LOGINMODAL,
  UPDATE_REPORTSMODAL,
  CANCEL_FACILITIES,
} from "./types";

import axios from "axios";
var CancelToken = axios.CancelToken;

let cf;
export const cancelFetchFacilities = (queryString, options) => dispatch => {
  if (cf) cf();
}

export const fetchFacilities = (queryString, options, payload) => dispatch => {
  dispatch({
    type: FETCH_FACILITIES,
    payload: [],
    keyword: "",
    isFetching: true,
    options: options,
    filters: options,
  });

  delete options.total_records;

  axios.get(`api/v1/hwts/search/all${queryString}`,
    {
      cancelToken: new CancelToken(function executor(c) {
        cf = c;
      })
    })
    .then(results => {
      dispatch({
        type: FETCH_FACILITIES,
        payload: results.data.data.facilities,
        isFetching: false,
        options: results.data.data.filters,
        filters: options,
        keyword: results.data.data.filters.fromkeyword
      });
    })
    .catch(function (thrown) {
      if (axios.isCancel(thrown)) {
        console.log('Axios Request canceled', thrown.message);
        dispatch({
          type: FETCH_FACILITIES,
          payload: [],
          isFetching: false,
          options: options,
          filters: options,
        })
      }
    });
};

export const fetchFacility = (epa_id, entityType) => dispatch => {
  if (entityType === "generator") {
    axios.get(`api/v1/hwts/search/facility?epaid=${epa_id}`).then(generator => {
      dispatch({
        type: FETCH_GENERATOR,
        payload: generator.data,
        isFetching: false
      });
    });
  } else if (entityType === "trans1") {
    axios.get(`api/v1/hwts/search/facility?epaid=${epa_id}`).then(trans1 => {
      dispatch({
        type: FETCH_TRANS1,
        payload: trans1.data,
        isFetching: false
      });
    });
  } else if (entityType === "trans2") {
    axios.get(`api/v1/hwts/search/facility?epaid=${epa_id}`).then(trans2 => {
      dispatch({
        type: FETCH_TRANS2,
        payload: trans2.data,
        isFetching: false
      });
    });
  } else if (entityType === "tsdf") {
    axios.get(`api/v1/hwts/search/facility?epaid=${epa_id}`).then(tsdf => {
      dispatch({
        type: FETCH_TSDF,
        payload: tsdf.data,
        isFetching: false
      });
    });
  } else if (entityType === "altTsdf") {
    axios.get(`api/v1/hwts/search/facility?epaid=${epa_id}`).then(altTsdf => {
      dispatch({
        type: FETCH_ALTTSDF,
        payload: altTsdf.data,
        isFetching: false
      });
    });
  } else {
    axios.get(`api/v1/hwts/search/facility?epaid=${epa_id}`).then(facility => {
      dispatch({
        type: FETCH_FACILITY,
        payload: facility.data,
        isFetching: false
      });
    });
  }
};

export const updateSelection = (
  epa_id,
  facName,
  facStreet1,
  facCity,
  facCounty,
  facZip,
  facLat,
  facLng,
  showInfoWindow,
  from
) => dispatch => {
  dispatch({
    type: UPDATE_SELECTION,
    epa_id,
    facName,
    facStreet1,
    facCity,
    facCounty,
    facZip,
    facLat,
    facLng,
    showInfoWindow,
    from
  });
};

export const updateLoginModal = isLoginModalOpen => dispatch => {
  dispatch({
    type: UPDATE_LOGINMODAL,
    isLoginModalOpen
  });
};

export const updateReportsModal = isReportsModalOpen => dispatch => {
  dispatch({
    type: UPDATE_REPORTSMODAL,
    isReportsModalOpen
  });
};

export const resetFacilities = () => dispatch => {
  dispatch({
    type: FETCH_FACILITIES,
    payload: [],
    isFetching: false,
    keyword: "",
    options: {
      sort: "EPA_ID",
      sortBy: "ASC",
      page: 1,
      pageSize: 10,
      total_records: 0
    }
  });
};

export const resetSearch = () => dispatch => {
  dispatch({
    type: RESET_SEARCH,
    payload: [],
    isFetching: false,
  })
}
